import { Injectable } from "@angular/core";
import { Response } from "@angular/http";
import { Observable } from "rxjs/Observable";

import { CrudService } from "@atenea-cms";
import { Category } from "./category.model";

@Injectable()
export class CategoryService extends CrudService {
  getRootUrl(): string {
    return "categories";
  }

  save(category: Category) {
    return super.save(category);
  }

  saveMultiple(categories: Array<Category>) {
    return super.saveMultiple(categories);
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/categories/shared/category.service.ts